import React from 'react';
import PropTypes from 'prop-types';

const ButtonPrimary = ({ children, isDisabled = false, className = '', ...props }) => {
    return (
        <button
            className={`
                px-3 py-2 text-xs font-semibold text-white rounded-t rounded-b bg-gradient-to-r from-primary to-secondary
                ${isDisabled ? 'opacity-50' : 'hover:outline-none hover:via-primary hover:to-secondary focus:outline-none focus:to-primary'}
                ${className}
            `}
            disabled={isDisabled}
            {...props}
        >
            {children}
        </button>
    );
};

ButtonPrimary.propTypes = {
    children: PropTypes.node.isRequired,
    isDisabled: PropTypes.bool,
    className: PropTypes.string,
};

export default ButtonPrimary;
